/**
 * @file 支払い済み共済金合計を算出
 */
'use strict'

/**
 * @classname CalculateTotalPaidMutualAid
 * @classdesc 支払い済み共済金合計を算出
 */
 export default class CalculateTotalPaidMutualAid {
	/**
	 * @constructor
	 * @param {jQuery} $e - $('.paid-mutual-aid-total')
	 */
	constructor($e, controller) {
		console.log('CalculateTotalPaidMutualAid.constructor')
		this._$e = $e
		this._controller = controller
		this._paymentPrice = $('.payment_price').val()
		this._$mutualAidCompareResult = $('.mutual-aid-compare-result')
		this.calculate()
		this._controller.on('total-paid-mutual-aid-calculate', () => this.calculate())
	}


	/**
	 * 'change' のコールバック
	 *
	 * @memberof CalculateTotalPaidMutualAid
	 * @return {undefined}
	 */
	calculate() {
		console.log('CalculateTotalPaidMutualAid.calculate')
		let paidPrice = 0
		$('.list-paid-mutual-aid').find('.paid_mutual_aid_price').each((_, element) => {
			paidPrice += Number($(element).val())
		})
		this._$e.text(`${paidPrice.toLocaleString()}円`)
		let compareResult = this._paymentPrice - paidPrice
		switch(true) {
			case (0 < compareResult): {
				this._$mutualAidCompareResult.text(`残り${compareResult.toLocaleString()}円`)
			}
			break;
			case (compareResult < 0): {
				this._$mutualAidCompareResult.text(`${Math.abs(compareResult).toLocaleString()}円過払い`)
			}
			break;
			default: {
				this._$mutualAidCompareResult.text(`±0円`)
			}
		}
	}
}
